export const financePermissions = (storedRoles = localStorage.getItem('roles')) => {
  let roles;
  try { roles = JSON.parse(storedRoles || '[]'); } catch { roles = []; }
  const set = new Set((Array.isArray(roles) ? roles : []).map(role => String(role).toUpperCase()));
  const writeAllocations = set.has('ROLE_RECEIPT_ALLOCATION_WRITE');
  const readAllocations = writeAllocations || set.has('ROLE_RECEIPT_ALLOCATION_READ');
  return {
    readAllocations,
    readReceiptAllocations: readAllocations || set.has('ROLE_RECEIPT_ACCOUNTING'),
    writeAllocations,
    readTransactions: set.has('ROLE_BANK_TRANSACTION_READ'),
  };
};
